import React, { memo } from "react";

export const EmptySpace = memo(() => <> </>);
